module.exports = __webpack_public_path__ + "static/media/error.e289cd48.png";